export type VerticalPosition = 'top' | 'bottom';
export type HorizontalPosition = 'left' | 'center' | 'right';
export const createPositionProps = ({
  vertical = 'bottom',
  horizontal = 'center',
}: {
  vertical?: VerticalPosition;
  horizontal?: HorizontalPosition;
}) =>
  ({
    anchorOrigin: {
      vertical,
      horizontal,
    },
    transformOrigin: {
      vertical: vertical === 'top' ? 'bottom' : 'top',
      horizontal,
    },
  } as const);
